import React from 'react';
import {
  CodeIcon,
  TerminalIcon,
  CpuIcon,
  ZapIcon,
  GlobeIcon,
  ShieldIcon,
  CompassIcon,
  LayersIcon,
  RocketIcon,
  SparklesIcon,
  BugIcon,
  FlaskIcon,
  PuzzleIcon,
  LightbulbIcon,
  KeyboardIcon,
  FlameIcon,
  UserIcon
} from '../components/Icons.jsx';

export const AVATARS = [
  { id: 'code', label: 'Code', icon: CodeIcon, bg: '#059669', color: '#34d399' },
  { id: 'terminal', label: 'Terminal', icon: TerminalIcon, bg: '#0284c7', color: '#38bdf8' },
  { id: 'cpu', label: 'Core', icon: CpuIcon, bg: '#7c3aed', color: '#a78bfa' },
  { id: 'zap', label: 'Spark', icon: ZapIcon, bg: '#d97706', color: '#fbbf24' },
  { id: 'globe', label: 'Network', icon: GlobeIcon, bg: '#2563eb', color: '#60a5fa' },
  { id: 'shield', label: 'Security', icon: ShieldIcon, bg: '#4f46e5', color: '#818cf8' },
  { id: 'compass', label: 'Explorer', icon: CompassIcon, bg: '#0d9488', color: '#2dd4bf' },
  { id: 'layers', label: 'Stack', icon: LayersIcon, bg: '#e11d48', color: '#fb7185' },
  { id: 'rocket', label: 'Rocket', icon: RocketIcon, bg: '#ea580c', color: '#fb923c' },
  { id: 'sparkles', label: 'Spark+', icon: SparklesIcon, bg: '#db2777', color: '#f472b6' },
  { id: 'bug', label: 'Debug', icon: BugIcon, bg: '#65a30d', color: '#a3e635' },
  { id: 'flask', label: 'Lab', icon: FlaskIcon, bg: '#0891b2', color: '#22d3ee' },
  { id: 'puzzle', label: 'Puzzle', icon: PuzzleIcon, bg: '#9333ea', color: '#c084fc' },
  { id: 'bulb', label: 'Idea', icon: LightbulbIcon, bg: '#f59e0b', color: '#fcd34d' },
  { id: 'keyboard', label: 'Keys', icon: KeyboardIcon, bg: '#475569', color: '#94a3b8' },
  { id: 'flame', label: 'Flame', icon: FlameIcon, bg: '#dc2626', color: '#f87171' },
];

// Mapping for legacy avatar IDs
const LEGACY_MAP = {
  cat: 'code',
  dog: 'terminal',
  fox: 'cpu',
  panda: 'zap',
  owl: 'globe',
  lion: 'shield',
  penguin: 'compass',
  koala: 'layers',
};

export function getAvatarInfo(id) {
  const resolvedId = LEGACY_MAP[id] || id;
  return AVATARS.find((a) => a.id === resolvedId) || AVATARS[0];
}

/**
 * Clean Vector Avatar Badge Component
 */
export function AvatarBadge({ avatar, size = 'md', className = '' }) {
  const info = getAvatarInfo(avatar);
  const IconComponent = info.icon || UserIcon;

  const sizeClass = size === 'sm' ? 'avatar-badge-sm' : size === 'lg' ? 'avatar-badge-lg' : size === 'xl' ? 'avatar-badge-xl' : 'avatar-badge-md';
  const iconSize = size === 'sm' ? 14 : size === 'lg' ? 26 : size === 'xl' ? 36 : 18;

  return (
    <div
      className={`avatar-badge ${sizeClass} ${className}`}
      style={{
        '--avatar-bg': info.bg,
        '--avatar-color': info.color,
      }}
      aria-label={info.label}
    >
      <IconComponent size={iconSize} />
    </div>
  );
}

// Backward-compatibility function for places that invoked avatarEmoji()
export function avatarEmoji(id) {
  return <AvatarBadge avatar={id} size="md" />;
}
